import { useEffect, useRef } from 'react';

export const useMouseEffects = () => {
  const pointerRef = useRef(null);
  // Ajout d'une variable d'état pour requestAnimationFrame
  let frameId = useRef(null);

  const enlargePointer = () => {
    if (pointerRef.current) {
      pointerRef.current.classList.add("expanded");
    }
  };

  const restorePointerSize = () => {
    if (pointerRef.current) {
      pointerRef.current.classList.remove("expanded");
    }
  };

  useEffect(() => {
    const movePointer = (e) => {
      // Annulation de la frame précédente pour s'assurer qu'il n'y a pas d'accumulation d'appels non traités
      if (frameId.current) {
        cancelAnimationFrame(frameId.current);
      }
      
      frameId.current = requestAnimationFrame(() => {
        if (pointerRef.current) {
          pointerRef.current.style.left = `${e.clientX}px`;
          pointerRef.current.style.top = `${e.clientY}px`;
        }
      });
    };

    const checkHoveredElement = (e) => {
      if (e.target.tagName === 'BUTTON' || e.target.tagName === 'A') {
        enlargePointer();
      } else {
        restorePointerSize();
      }
    };

    window.addEventListener("mousemove", movePointer);
    window.addEventListener("mouseover", checkHoveredElement);

    return () => {
      window.removeEventListener("mousemove", movePointer);
      window.removeEventListener("mouseover", checkHoveredElement);
      // Assurez-vous d'annuler la frame requestAnimationFrame lors du nettoyage
      if (frameId.current) {
        cancelAnimationFrame(frameId.current);
      }
    };
  }, []);

  return pointerRef;
};